import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import '@aytm/lib/rfd-ui/styles/advanced/color-palette.scss'
import useOuterClickListener from '@aytm/lib/rfd-ui/lib/outer-click-listener'

const CLASS = 'rfd-ui-color-palette'

const palette = [
  [null, '#88d1cd', '#29abe2', '#1c67aa', '#223d64'],
  ['#d9fc21', '#c2e021', '#8cc63f', '#009245', '#01502b'],
  ['#ffd700', '#fbb03b', '#ff7700', '#ed1c1c', '#c1272d'],
  ['#ce88bc', '#8c3375', '#683389', '#46338b', '#28056b'],
  ['#dddddd', '#cccccc', '#999999', '#666666', '#333333'],
  ['#e3f4f4', '#ded2e5', '#f4e3f4', '#e5ded2', '#d2e5de']
]

const onPanelClick = event => event.stopPropagation()

const ColorPalette = props => {
  const panelRef = useRef()
  const containerRef = useRef()

  const [show, setShow] = useState(false)

  const [color, setColor] = useState(props.color)

  const onColorClick = event => {
    setShow(false)
    if (props.onSelect) props.onSelect({ name: props.name, color: event.color })
  }

  const onInputChange = event => {
    const inputColor = event.target.value
    setColor(inputColor)
    if (CSS.supports('color', inputColor) && props.onSelect) {
      props.onSelect({ name: props.name, color: inputColor })
    }
  }

  const onInputKeyPress = event => {
    if (['escape', 'Enter'].includes(event.key)) setShow(false)
  }

  const renderPanel = () => {
    const items = palette.map((row, rowIndex) => {
      const colors = row.map((col, colIndex) => {
        const panelColor = col || '#fff'
        const className = 0 === rowIndex && 0 === colIndex ? `${CLASS}-color ${CLASS}-color-empty` : `${CLASS}-color`
        return (
          <div
            key={colIndex}
            className={className}
            style={{ backgroundColor: panelColor }}
            onClick={() => onColorClick({ color: panelColor })}
          />
        )
      })
      return (
        <div key={rowIndex} className={`${CLASS}-line`}>
          {colors}
        </div>
      )
    })

    items.push(
      <input
        key={palette.length}
        className={`${CLASS}-input`}
        type={'text'}
        value={color}
        onChange={onInputChange}
        onKeyPress={onInputKeyPress}
      />
    )

    const rect = containerRef.current ? containerRef.current.getBoundingClientRect() : null
    const style = rect ? { right: 0, top: `${rect.height + 4}px` } : {}

    return (
      <div ref={panelRef} className={`${CLASS}-panel`} style={style} tabIndex={1} onClick={onPanelClick}>
        {items}
      </div>
    )
  }

  const onClick = event => {
    event.stopPropagation()
    setShow(!show)
  }

  useEffect(() => {
    if (props.color !== color) setColor(color)
  }, [color, props.color])

  useOuterClickListener({ ref: panelRef, listen: show, onClick: () => setShow(false) })

  const panel = show ? renderPanel() : null

  const pickerStyle = { backgroundColor: props.color }

  const label = props.label ? <div className={`${CLASS}-label`}>{props.label}</div> : null

  const iconClass = show
    ? `icon-aytmfd-up ${CLASS}-icon ${CLASS}-icon-selector`
    : `icon-aytmfd-down ${CLASS}-icon ${CLASS}-icon-selector`

  const className = props.className ? `${CLASS} ${props.className}` : CLASS

  return (
    <div className={className} ref={containerRef}>
      {label}
      <div className={`${CLASS}-picker`} style={pickerStyle} onClick={onClick} />
      <i className={iconClass} onClick={onClick} />
      {panel}
    </div>
  )
}

ColorPalette.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  show: PropTypes.any,
  color: PropTypes.string,
  label: PropTypes.any,
  onSelect: PropTypes.func,
  onClick: PropTypes.func
}

export default ColorPalette
